var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.54394 20V10.8738H10.6066L11.0656 7.31686H7.54394V5.04854C7.54394 4.01589 7.82638 3.31862 9.30917 3.31862H11.1891V0.141218C10.8626 0.0970876 9.74164 0 8.4442 0C5.72576 0 3.87227 1.65931 3.87227 4.6955V7.31686H0.800781V10.8738H3.87227V20H7.54394Z",
    fill: "#B3B3C9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.f713f89a816e36b97e929b8a25f81fbf.svg";
export { ForwardRef as ReactComponent };